import * as React from "react";

const ProductLists: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.964 30" fill="currentColor">
            <g fill="none">
                <path
                    fill="#00205C"
                    d="m.24 22.945 13.994 6.997h.039c.116.077.27.077.387 0h.038l13.995-6.997a.536.536 0 0 0 .27-.464V7.365c0-.039-.038-.039-.038-.078-.039-.077-.116-.116-.155-.154h-.038L14.698.058a.493.493 0 0 0-.464 0L.24 7.055H.201l-.039.04-.039.038s-.038.038-.038.077l-.039.039c0 .038-.039.038-.039.077v15.155a.414.414 0 0 0 .232.464ZM.973 8.33l12.99 6.495v13.879L.974 22.21V8.331Zm26.985 13.88-12.99 6.494V14.826l3.982-2.01v1.198c0 .155.077.348.232.425.154.078.348.116.502.04l3.982-2.011a.536.536 0 0 0 .27-.464v-1.701l3.983-2.01.039 13.917ZM7.469 4.58l12.874 6.456-.89.426L6.58 5.006l.889-.425Zm2.01-1.005 12.874 6.456-.89.425L8.59 4.001l.89-.425Zm10.477 8.737 3.015-1.508v.89l-3.015 1.507v-.889Zm-5.49-11.25L27.34 7.52l-3.866 1.933L10.6 3.035l3.866-1.972ZM5.46 5.586l12.873 6.418-3.866 1.933L1.593 7.519l3.866-1.933Z"
                />
                <path
                    fill="#FFCD00"
                    d="m23.513 13.434-4.446 2.243a2.002 2.002 0 0 0-1.121 1.778v.27c0 .348.193.658.464.851.309.193.657.193.966.039l4.446-2.243a2.002 2.002 0 0 0 1.121-1.778v-.27c0-.348-.193-.658-.464-.851-.27-.193-.657-.193-.966-.039Zm.464 1.16c0 .387-.232.735-.542.89l-4.446 2.242v-.271c0-.387.232-.735.542-.89l4.446-2.242v.271Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(ProductLists);
